<gob-back (back)="back.emit(true)"></gob-back>
<form (ngSubmit)="savePrivateNote(form)" #form="ngForm">
  <div class="form-floating mb-2">
    <input type="hidden" name="note" [(ngModel)]="request.note"/>
    <textarea class="form-control" id="order-privatecomment" [(ngModel)]="request.content" name="content" style="height: 150px;" required></textarea>
    <label for="order-privatecomment" class="label-add-pnote">Ajouter une note interne</label>
  </div>
  <div class="btn-container">
    <button scrollTo type="submit" class="btn green" [disabled]="form.invalid">{{ editNote ? 'Mettre à jour' : 'Ajouter' }}</button>
  </div>

</form>

